import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMedebewonerInschrijven = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M27 17c3.31 0 6 2.63 6 5.88V34H21V22.88c0-3.25 2.69-5.88 6-5.88"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      d="M27 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12M13 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M13 18c3.31 0 6 2.69 6 6v10H7V24c0-3.31 2.69-6 6-6"
      clipRule="evenodd"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="M27 12c0 1.66-1.34 3-3 3s-3-1.34-3-3M17 14c0 1.66-1.34 3-3 3s-3-1.34-3-3"
    />
    <path
      fill="#0061CD"
      d="M23 18h-6v18h6z"
    />
    <path
      fill="#0061CD"
      d="M29 30v-6H11v6z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMedebewonerInschrijven);

export default ForwardRef;
